import { createFileRoute } from '@tanstack/react-router'

import { UomFormPage } from '@/features/inventory/components/uom-form-page'

export const Route = createFileRoute('/_app/inventory/uom/create')({
  loader: () => ({
    crumb: 'Tambah Unit',
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  return (
    <UomFormPage mode='create' onBack={() => navigate({ to: '/inventory/uom', replace: true })} />
  )
}
